<template>
    <div id="container">
            <img ref="CandleLit" class="noselect" v-for="(candle, index) in candleSrcs" :key="index" :src="candle" :class="{lit: candle === 'Candle-lit.png'}">
           
    </div>
    <LastStand :isLastStand="isLastStand"/>
 <audio ref="audioPlayer">
     <source ref="audioSource" :src="audioSrc"/>
        Your browser does not support this audio format
 </audio>
</template>

<script>
import LastStand from './LastStand.vue';
import {useCandleStore} from "../store/useCandleStore";
import { storeToRefs } from 'pinia';

export default {
    

  name: 'CandlesComponent',
  components:{
      LastStand
  },

    setup(){
        let store = useCandleStore();
        let { candles, isLastStand } = storeToRefs(store);
        return {
            candles,
            isLastStand
        }
    },

    data() {
        return {
            offset: 2,
            candleSrcs:["Candle-lit.png", "Candle-lit.png","Candle-lit.png","Candle-lit.png","Candle-lit.png","Candle-lit.png","Candle-lit.png","Candle-lit.png","Candle-lit.png","Candle-lit.png"],
            audioClip: 0,
            audioIndex:0,
            audioSrc:""
        }
    },
    mounted() {

        const candlePos = [0,1,2.5,3,3.3,3.3,3,2.5,1,0]
        const scale = [0,-1,-2,-3,-4,-4,-3,-2,-1,0]

        const marginTopModifier = -90;
        const scaleModifier = 7;

        const marginTopStartingValue = 100;
        const scaleStartingValue = 55;

        this.$refs.CandleLit.forEach((candle, index) => {
            candle.style.marginTop = candlePos[index]* marginTopModifier + marginTopStartingValue+"px"
            candle.style.height = scale[index]*scaleModifier + scaleStartingValue+"%"
            candle.classList.add("candle"+(index+1))
        });

        this.changeMatchSound();
        
    },
    methods:{
        outACandle(){
            this.candleSrcs[9-this.candles] = "Candle-out.png";
            this.$refs.audioPlayer.play();
            this.changeMatchSound();

        },
        changeMatchSound(){
            let clips = [
                "out-2.mp3",
                "out-1.mp3",
                "out-3.mp3",
                "out-4.mp3",
            ]
            if(this.audioIndex < clips.length-1) this.audioIndex++;
            else this.audioIndex = 0;
            
            this.audioSrc = "sounds/"+clips[this.audioIndex];
            setTimeout(()=>this.$refs.audioPlayer.load(), 3000);


        }
    }
}
</script>

<style scoped>
    #container {
        flex: 10;
        align-items: center;
        justify-content: center;
        gap: 2vw;
        display:flex;
        border-width: 0pt;
        border-style: solid;
        border-color: orangered;
    }

    
    img {
        filter:drop-shadow(0px -5px 10px rgb(31, 31, 31)) saturate(170%) brightness(10%) contrast(60%) ;
    }


    .lit{
        filter:drop-shadow(0px 0px 100px rgb(221, 168, 23)) sepia(60%) saturate(220%) brightness(80%) contrast(150%);
        transition: filter 0.5s ease-in-out; 
        
    }

    .lit:hover{
        filter:drop-shadow(0px -10px 50px rgb(221, 168, 23)) sepia(50%) saturate(170%) brightness(90%) contrast(120%);
    }
    


    .lit.candle1 {
        animation: candle-flicker 3s ease infinite;
    }

    .lit.candle2 {
        animation: candle-flicker 3.2s ease infinite;
    }

    .lit.candle3 {
        animation: candle-flicker 3.6s ease infinite;
    }

    .lit.candle4 {
        animation: candle-flicker 3.3s ease infinite;
    }

    .lit.candle5 {
        animation: candle-flicker 3.1s ease infinite;
    }

    .lit.candle6 {
        animation: candle-flicker 3.8s ease infinite;
    }

    .lit.candle7 {
        animation: candle-flicker 3.4s ease infinite;
    }

    .lit.candle8 {
        animation: candle-flicker 3.9s ease infinite;
    }

    .lit.candle9 {
        animation: candle-flicker 3.5s linear infinite;
    }

    .lit.candle10 {
        animation: candle-flicker 3.7s linear infinite;
    }

  



</style>